import { createFileRoute } from "@tanstack/react-router"
import { FilesListPage } from "@/components/pages/FilesListPage"
import { NotFound } from "@/components/NotFound"
import { useCanonicalId } from "@/lib/hooks/use-canonical-id"

function FilesRoute() {
  const { tripId: param } = Route.useParams()
  const tripId = useCanonicalId(`trip`, param)
  if (tripId === undefined) return null
  if (tripId === null) return <NotFound />
  return <FilesListPage tripId={tripId} />
}

// Data loads via tRPC/React Query on mount (useTripData + uploads.listTripFiles);
// no react-db preload needed.
export const Route = createFileRoute(
  `/_authenticated/trip/$slug/$tripId/files`
)({
  component: FilesRoute,
  ssr: false,
})
